export const CookieName = Object.freeze({
    DASHBOARD_ALERTS_DISMISSED: "sbx-dashboard-alerts-dismissed",
});
